export {
  appendQuery
} from './appendQuery.js'

export const initDocumentFontSize = () => {
  let resetFontSize = () => {
    let bodyWidth = document.body.clientWidth
    let fontSize = bodyWidth <= 414 ? 100 * bodyWidth / 750 : 100 * 414 / 750
    document.documentElement.style.fontSize = fontSize + 'px'
  }
  resetFontSize()
  window.addEventListener('load', resetFontSize, false)
  window.addEventListener('orientationchange', resetFontSize, false)
  window.addEventListener('resize', resetFontSize, false)
}

export const hmt = () => { // 百度统计已经加在页面head里面
  var _hmt = _hmt || [];
  (function() {
    var hm = document.createElement("script");
    hm.src = "https://hm.baidu.com/hm.js?aedb62970cd2e5b7dd727bfed37ac6c5";
    var s = document.getElementsByTagName("script")[0];
    s.parentNode.insertBefore(hm, s);
  })();
}

export function parseParams (id, params) {
  const index = id.indexOf(':')
  if (index !== -1) {
    const key = id.substr(index + 1)
    const value = params[key]
    return id.replace(/:.*$/g, value)
  } else {
    return id
  }
}
